"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _rcTable = require("rc-table");
var _Column = _interopRequireDefault(require("./Column"));
var _ColumnGroup = _interopRequireDefault(require("./ColumnGroup"));
var _useSelection = require("./hooks/useSelection");
var _InternalTable = _interopRequireDefault(require("./InternalTable"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Table = (props, ref) => {
  const renderTimesRef = React.useRef(0);
  renderTimesRef.current += 1;
  return /*#__PURE__*/React.createElement(_InternalTable.default, Object.assign({}, props, {
    ref: ref,
    _renderTimes: renderTimesRef.current
  }));
};
const ForwardTable = /*#__PURE__*/React.forwardRef(Table);
ForwardTable.SELECTION_COLUMN = _useSelection.SELECTION_COLUMN;
ForwardTable.EXPAND_COLUMN = _rcTable.EXPAND_COLUMN;
ForwardTable.SELECTION_ALL = _useSelection.SELECTION_ALL;
ForwardTable.SELECTION_INVERT = _useSelection.SELECTION_INVERT;
ForwardTable.SELECTION_NONE = _useSelection.SELECTION_NONE;
ForwardTable.Column = _Column.default;
ForwardTable.ColumnGroup = _ColumnGroup.default;
ForwardTable.Summary = _rcTable.Summary;
if (process.env.NODE_ENV !== 'production') {
  ForwardTable.displayName = 'Table';
}
var _default = exports.default = ForwardTable;